import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router =  new Router({
  mode:'history',
  routes: [
   { path: '/', name: 'home', component: resolve => require(['@/view/home/index.vue'],resolve),meta:{isHeader:true,requireAuth:1}},
   { path: '/login', name: 'login', component: resolve => require(['@/view/login/login.vue'],resolve) ,meta:{isHeader:false,requireAuth:0}},
   { path: '/home', name: 'home', component: resolve => require(['@/view/home/index.vue'],resolve) ,meta:{isHeader:true,requireAuth:1}},
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
router.beforeEach((to, from, next) => {
  const hasToken = !!window.localStorage.getItem('token')
  // 1 = 需要登录；0 = 已登录则跳首页。其他值保持原行为（不调用 next）
  if (to.meta.requireAuth == 1 && !hasToken) next('/login')
  else if (to.meta.requireAuth == 0 && hasToken) next('/home')
  else next()
})
export default router
